import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-search\"><defs><style></style></defs><path d=\"M936.445 886.349L773.859 723.763c62.557-72.205 96.698-163.441 96.698-259.929 0-106.211-41.36-206.064-116.463-281.168C678.99 107.565 579.137 66.204 472.925 66.204c-106.21 0-206.064 41.36-281.166 116.463S75.297 357.624 75.297 463.834s41.36 206.064 116.463 281.168c75.102 75.102 174.956 116.463 281.166 116.463 87.749 0 171.142-28.255 239.84-80.42l164.492 164.492c8.172 8.172 18.883 12.26 29.594 12.26s21.422-4.088 29.594-12.26c16.343-16.345 16.343-42.844-.001-59.188zM159 463.834c0-173.1 140.827-313.926 313.925-313.926 173.1 0 313.927 140.827 313.927 313.926S646.024 777.759 472.925 777.759C299.827 777.759 159 636.933 159 463.834z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/search.svg
// module id = EqOI
// module chunks = 78